import { Link } from 'react-router-dom';
import './HeaderNav.css';

const headerLinks = [
    {
        href: '/black-market',
        text: 'ЧЕРНЫЙ РЫНОК',
    },
    {
        href: '/',
        text: 'БАНДЫ',
    },
    {
        href: '/',
        text: 'ТОП ГАНГСТЕРОВ',
    },
    {
        href: '/',
        text: 'ЗАРАБОТАТЬ',
    },
];
export const HeaderNav = () => {
    return (
        <nav className="header-navigation">
            {headerLinks.map((item, i) => (
                <Link className="header-navigation__links" key={i} to={item.href}>
                    {item.text}
                </Link>
            ))}
        </nav>
    );
};
